import * as Sentry from '@sentry/nextjs';

import { APIRequestLabel } from '../consts';
import { callHttpGet, callHttpPost, callHttpPut } from '../http';

const createGarminConnection = (get, set) => {
  return async () => {
    await callHttpPost(
      get,
      set,
      APIRequestLabel.CREATE_GARMIN_CONNECTION,
      `/sensor_providers/connections`,
      {}
    );
    let apiCallStatus = get().apiCallStatus[APIRequestLabel.CREATE_GARMIN_CONNECTION];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return;
    }
    // redirect to garmin authorization url
    const authorizationUrl = apiCallStatus.response['authorizationUrl'];
    authorizationUrl && window.open(authorizationUrl, '_self');

    // update connections
    await callHttpGet(
      get,
      set,
      APIRequestLabel.GET_GARMIN_CONNECTIONS,
      `/sensor_providers/connections`
    );
    apiCallStatus = get().apiCallStatus[APIRequestLabel.GET_GARMIN_CONNECTIONS];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return;
    }
    set({ garminConnections: apiCallStatus.response?.connections });
  };
};

const authorizeGarminConnection = (get, set) => {
  return async (oauthVerifier: string) => {
    await callHttpPut(
      get,
      set,
      APIRequestLabel.AUTHORIZE_GARMIN_CONNECTION,
      `/sensor_providers/connections/oauth/authorize`,
      {
        oauthVerifier: oauthVerifier
      }
    );
    let apiCallStatus = get().apiCallStatus[APIRequestLabel.AUTHORIZE_GARMIN_CONNECTION];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return;
    }
  };
};

const getGarminConnections = (get, set) => {
  return async () => {
    await callHttpGet(
      get,
      set,
      APIRequestLabel.GET_GARMIN_CONNECTIONS,
      `/sensor_providers/connections`
    );
    let apiCallStatus = get().apiCallStatus[APIRequestLabel.GET_GARMIN_CONNECTIONS];
    if (apiCallStatus.error) {
      Sentry.captureMessage(JSON.stringify(apiCallStatus.error));
      return;
    }
    set({ garminConnections: apiCallStatus.response?.connections });
  };
};

export { authorizeGarminConnection, createGarminConnection, getGarminConnections };
